export default function DestinationBanner({ d, idx }) {
  return (
    <div className="relative aspect-[21/9] md:aspect-[21/8] overflow-hidden mb-16 img-zoom">
      <img
        src={d.hero}
        alt={d.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" />
      <div className="absolute inset-0 p-8 md:p-16 flex flex-col justify-between">
        <div className="text-[11px] tracking-widest3 uppercase text-ivory/80">
          Chapter 0{idx + 1}
        </div>
        <div>
          <h2 className="font-serif text-7xl md:text-[10rem] text-ivory font-light leading-none tracking-tighter">
            {d.name}
          </h2>
          <div className="mt-4 text-goldleaf italic font-serif text-xl md:text-2xl max-w-xl">
            {d.tagline}
          </div>
        </div>
      </div>
    </div>
  );
}
